
import makeupOne from './cos-img/product-img/products/makeup/blusher/blush (5).jpg';
import makeupTwo from './cos-img/product-img/products/makeup/bridal-makeup/makeup (6).jpg';
import makeupThree from './cos-img/product-img/products/makeup/blusher/blush (28).jpg';
import makeupFour from './cos-img/product-img/products/makeup/blusher/blush (35).jpg';


import hairOne from './cos-img/product-img/products/shampoo/garnier/hair (37).jpg';
import hairTwo from './cos-img/product-img/products/shampoo/provost/hair (1).jpg';
import hairThree from './cos-img/product-img/products/shampoo/loreal/hair (25).jpg';
import hairFour from './cos-img/product-img/products/shampoo/loreal/hair (31).jpg';
import hairFive from './cos-img/product-img/products/shampoo/TRESemme/hair (1).jpg';
import hairSix from './cos-img/product-img/products/shampoo/loreal/hair (3).jpg';
import hairSeven from './cos-img/product-img/products/shampoo/loreal/hair (19).jpg';
import hairEight from './cos-img/product-img/products/shampoo/loreal/hair (20).jpg';
import hairNine from './cos-img/product-img/products/shampoo/loreal/hair (21).jpg';
import hairTen from './cos-img/product-img/products/shampoo/loreal/hair (24).jpg';
import hair11 from './cos-img/product-img/products/shampoo/loreal/hair (26).jpg';
import hair12 from './cos-img/product-img/products/shampoo/loreal/hair (27).jpg';
import hair13 from './cos-img/product-img/products/shampoo/loreal/hair (32).jpg';
import hair14 from './cos-img/product-img/products/shampoo/loreal/hair (33).jpg';
import hair15 from './cos-img/product-img/products/shampoo/loreal/hair (34).jpg';
import hair16 from './cos-img/product-img/products/shampoo/loreal/hair (35).jpg';
import hair17 from './cos-img/product-img/products/shampoo/loreal/hair (39).jpg';
import hair18 from './cos-img/product-img/products/shampoo/loreal/hair (43).jpg';
import hair19 from './cos-img/product-img/products/shampoo/loreal/hair (44).jpg';
import hair20 from './cos-img/product-img/products/shampoo/loreal/hair (54).jpg';
import hair21 from './cos-img/product-img/products/shampoo/loreal/hair (53).jpg';
import hair22 from './cos-img/product-img/products/shampoo/loreal/hair (55).jpg';
import hair23 from './cos-img/product-img/products/shampoo/loreal/hair (56).jpg';
import hair24 from './cos-img/product-img/products/shampoo/loreal/hair (57).jpg';
import hair25 from './cos-img/product-img/products/shampoo/loreal/hair (58).jpg';
import hair26 from './cos-img/product-img/products/shampoo/loreal/hair (59).jpg';
import hair27 from './cos-img/product-img/products/shampoo/loreal/hair (60).jpg';
import hair28 from './cos-img/product-img/products/shampoo/loreal/hair (61).jpg';
import hair29 from './cos-img/product-img/products/shampoo/loreal/hair (62).jpg';
import hair30 from './cos-img/product-img/products/shampoo/loreal/hair (63).jpg';
import hair31 from './cos-img/product-img/products/shampoo/loreal/hair (64).jpg';
import hair32 from './cos-img/product-img/products/shampoo/loreal/hair (65).jpg';
import hair33 from './cos-img/product-img/products/shampoo/loreal/hair (66).jpg';

import hair34 from './cos-img/product-img/products/shampoo/garnier/hair (1).jpg';
import hair35 from './cos-img/product-img/products/shampoo/garnier/hair (2).jpg';
import hair36 from './cos-img/product-img/products/shampoo/garnier/hair (3).jpg';
import hair37 from './cos-img/product-img/products/shampoo/garnier/hair (4).jpg';
import hair38 from './cos-img/product-img/products/shampoo/garnier/hair (5).jpg';
import hair39 from './cos-img/product-img/products/shampoo/garnier/hair (6).jpg';
import hair40 from './cos-img/product-img/products/shampoo/garnier/hair (7).jpg';
import hair41 from './cos-img/product-img/products/shampoo/garnier/hair (8).jpg';
import hair42 from './cos-img/product-img/products/shampoo/garnier/hair (9).jpg';
import hair43 from './cos-img/product-img/products/shampoo/garnier/hair (10).jpg';
import hair44 from './cos-img/product-img/products/shampoo/garnier/hair (11).jpg';
import hair45 from './cos-img/product-img/products/shampoo/garnier/hair (12).jpg';
import hair46 from './cos-img/product-img/products/shampoo/garnier/hair (13).jpg';
import hair47 from './cos-img/product-img/products/shampoo/garnier/hair (14).jpg';
import hair48 from './cos-img/product-img/products/shampoo/garnier/hair (15).jpg';
import hair49 from './cos-img/product-img/products/shampoo/garnier/hair (16).jpg';
import hair50 from './cos-img/product-img/products/shampoo/garnier/hair (17).jpg';
import hair51 from './cos-img/product-img/products/shampoo/garnier/hair (18).jpg';
import hair52 from './cos-img/product-img/products/shampoo/garnier/hair (19).jpg';
import hair53 from './cos-img/product-img/products/shampoo/garnier/hair (20).jpg';
import hair54 from './cos-img/product-img/products/shampoo/garnier/hair (21).jpg';
import hair55 from './cos-img/product-img/products/shampoo/garnier/hair (22).jpg';
import hair56 from './cos-img/product-img/products/shampoo/garnier/hair (23).jpg';
import hair57 from './cos-img/product-img/products/shampoo/garnier/hair (24).jpg';
import hair58 from './cos-img/product-img/products/shampoo/garnier/hair (25).jpg';
import hair59 from './cos-img/product-img/products/shampoo/garnier/hair (26).jpg';
import hair60 from './cos-img/product-img/products/shampoo/garnier/hair (27).jpg';
import hair61 from './cos-img/product-img/products/shampoo/garnier/hair (28).jpg';
import hair62 from './cos-img/product-img/products/shampoo/garnier/hair (29).jpg';
import hair63 from './cos-img/product-img/products/shampoo/garnier/hair (30).jpg';
import hair64 from './cos-img/product-img/products/shampoo/garnier/hair (31).jpg';
import hair65 from './cos-img/product-img/products/shampoo/garnier/hair (32).jpg';
import hair66 from './cos-img/product-img/products/shampoo/garnier/hair (33).jpg';
import hair67 from './cos-img/product-img/products/shampoo/garnier/hair (34).jpg';
import hair68 from './cos-img/product-img/products/shampoo/garnier/hair (35).jpg';
import hair69 from './cos-img/product-img/products/shampoo/garnier/hair (36).jpg';

import hair70 from './cos-img/product-img/products/shampoo/TRESemme/hair (2).jpg';
import hair71 from './cos-img/product-img/products/shampoo/TRESemme/hair (3).jpg';
import hair72 from './cos-img/product-img/products/shampoo/TRESemme/hair (4).jpg';
import hair73 from './cos-img/product-img/products/shampoo/TRESemme/hair (5).jpg';
import hair74 from './cos-img/product-img/products/shampoo/TRESemme/hair (6).jpg';
import hair75 from './cos-img/product-img/products/shampoo/TRESemme/hair (7).jpg';
import hair76 from './cos-img/product-img/products/shampoo/TRESemme/hair (8).jpg';
import hair77 from './cos-img/product-img/products/shampoo/TRESemme/hair (9).jpg';
import hair78 from './cos-img/product-img/products/shampoo/TRESemme/hair (10).jpg';
import hair79 from './cos-img/product-img/products/shampoo/TRESemme/hair (11).jpg';
import hair80 from './cos-img/product-img/products/shampoo/TRESemme/hair (12).jpg';
import hair81 from './cos-img/product-img/products/shampoo/TRESemme/hair (13).jpg';
import hair82 from './cos-img/product-img/products/shampoo/TRESemme/hair (14).jpg';
import hair83 from './cos-img/product-img/products/shampoo/TRESemme/hair (15).jpg';
import hair84 from './cos-img/product-img/products/shampoo/TRESemme/hair (16).jpg';
import hair85 from './cos-img/product-img/products/shampoo/TRESemme/hair (17).jpg';
import hair86 from './cos-img/product-img/products/shampoo/TRESemme/hair (18).jpg';
import hair87 from './cos-img/product-img/products/shampoo/TRESemme/hair (19).jpg';
import hair88 from './cos-img/product-img/products/shampoo/TRESemme/hair (20).jpg';
import hair89 from './cos-img/product-img/products/shampoo/TRESemme/hair (21).jpg';
import hair90 from './cos-img/product-img/products/shampoo/TRESemme/hair (22).jpg';
import hair91 from './cos-img/product-img/products/shampoo/TRESemme/hair (23).jpg';
import hair92 from './cos-img/product-img/products/shampoo/TRESemme/hair (24).jpg';
import hair93 from './cos-img/product-img/products/shampoo/TRESemme/hair (25).jpg';
import hair94 from './cos-img/product-img/products/shampoo/TRESemme/hair (26).jpg';
import hair95 from './cos-img/product-img/products/shampoo/TRESemme/hair (27).jpg';
import hair96 from './cos-img/product-img/products/shampoo/TRESemme/hair (28).jpg';
import hair97 from './cos-img/product-img/products/shampoo/TRESemme/hair (29).jpg';
import hair98 from './cos-img/product-img/products/shampoo/TRESemme/hair (30).jpg';

import hair99 from './cos-img/product-img/products/shampoo/nivea/hair (1).jpg';
import hair100 from './cos-img/product-img/products/shampoo/nivea/hair (2).jpg';
import hair101 from './cos-img/product-img/products/shampoo/nivea/hair (3).jpg';
import hair102 from './cos-img/product-img/products/shampoo/nivea/hair (4).jpg';
import hair103 from './cos-img/product-img/products/shampoo/nivea/hair (5).jpg';
import hair104 from './cos-img/product-img/products/shampoo/nivea/hair (6).jpg';
import hair105 from './cos-img/product-img/products/shampoo/nivea/hair (7).jpg';
import hair106 from './cos-img/product-img/products/shampoo/nivea/hair (8).jpg';
import hair107 from './cos-img/product-img/products/shampoo/nivea/hair (9).jpg';
import hair108 from './cos-img/product-img/products/shampoo/nivea/hair (10).jpg';
import hair109 from './cos-img/product-img/products/shampoo/nivea/hair (11).jpg';
import hair110 from './cos-img/product-img/products/shampoo/nivea/hair (12).jpg';
import hair111 from './cos-img/product-img/products/shampoo/nivea/hair (13).jpg';
import hair112 from './cos-img/product-img/products/shampoo/nivea/hair (14).jpg';
import hair113 from './cos-img/product-img/products/shampoo/nivea/hair (15).jpg';
import hair114 from './cos-img/product-img/products/shampoo/nivea/hair (16).jpg';
import hair115 from './cos-img/product-img/products/shampoo/nivea/hair (17).jpg';
import hair116 from './cos-img/product-img/products/shampoo/nivea/hair (18).jpg';
import hair117 from './cos-img/product-img/products/shampoo/nivea/hair (19).jpg';
import hair118 from './cos-img/product-img/products/shampoo/nivea/hair (20).jpg';
import hair119 from './cos-img/product-img/products/shampoo/nivea/hair (21).jpg';
import hair120 from './cos-img/product-img/products/shampoo/nivea/hair (22).jpg';
import hair121 from './cos-img/product-img/products/shampoo/nivea/hair (23).jpg';
import hair122 from './cos-img/product-img/products/shampoo/nivea/hair (24).jpg';

import hair123 from './cos-img/product-img/products/shampoo/provost/hair (2).jpg';
import hair124 from './cos-img/product-img/products/shampoo/provost/hair (3).jpg';
import hair125 from './cos-img/product-img/products/shampoo/provost/hair (4).jpg';
import hair126 from './cos-img/product-img/products/shampoo/provost/hair (5).jpg';
import hair127 from './cos-img/product-img/products/shampoo/provost/hair (6).jpg';
import hair128 from './cos-img/product-img/products/shampoo/provost/hair (7).jpg';
import hair129 from './cos-img/product-img/products/shampoo/provost/hair (8).jpg';
import hair130 from './cos-img/product-img/products/shampoo/provost/hair (9).jpg';
import hair131 from './cos-img/product-img/products/shampoo/provost/hair (10).jpg';
import hair132 from './cos-img/product-img/products/shampoo/provost/hair (11).jpg';
import hair133 from './cos-img/product-img/products/shampoo/provost/hair (12).jpg';
import hair134 from './cos-img/product-img/products/shampoo/provost/hair (13).jpg';
import hair135 from './cos-img/product-img/products/shampoo/provost/hair (14).jpg';
import hair136 from './cos-img/product-img/products/shampoo/provost/hair (15).jpg';
import hair137 from './cos-img/product-img/products/shampoo/provost/hair (16).jpg';
import hair138 from './cos-img/product-img/products/shampoo/provost/hair (17).jpg';
import hair139 from './cos-img/product-img/products/shampoo/provost/hair (18).jpg';
import hair140 from './cos-img/product-img/products/shampoo/provost/hair (19).jpg';
import hair141 from './cos-img/product-img/products/shampoo/provost/hair (20).jpg';
import hair142 from './cos-img/product-img/products/shampoo/provost/hair (21).jpg';
import hair143 from './cos-img/product-img/products/shampoo/provost/hair (22).jpg';
import hair144 from './cos-img/product-img/products/shampoo/provost/hair (23).jpg';
import hair145 from './cos-img/product-img/products/shampoo/provost/hair (24).jpg';
import hair146 from './cos-img/product-img/products/shampoo/provost/hair (25).jpg';
import hair147 from './cos-img/product-img/products/shampoo/provost/hair (26).jpg';

import hair148 from './cos-img/product-img/products/shampoo/syoss/hair (1).jpg';
import hair149 from './cos-img/product-img/products/shampoo/syoss/hair (2).jpg';
import hair150 from './cos-img/product-img/products/shampoo/syoss/hair (3).jpg';
import hair151 from './cos-img/product-img/products/shampoo/syoss/hair (4).jpg';
import hair152 from './cos-img/product-img/products/shampoo/syoss/hair (5).jpg';
import hair153 from './cos-img/product-img/products/shampoo/syoss/hair (6).jpg';
import hair154 from './cos-img/product-img/products/shampoo/syoss/hair (7).jpg';
import hair155 from './cos-img/product-img/products/shampoo/syoss/hair (8).jpg';
import hair156 from './cos-img/product-img/products/shampoo/syoss/hair (9).jpg';
import hair157 from './cos-img/product-img/products/shampoo/syoss/hair (10).jpg';
import hair158 from './cos-img/product-img/products/shampoo/syoss/hair (11).jpg';
import hair159 from './cos-img/product-img/products/shampoo/syoss/hair (12).jpg';
import hair160 from './cos-img/product-img/products/shampoo/syoss/hair (13).jpg';
import hair161 from './cos-img/product-img/products/shampoo/syoss/hair (14).jpg';
import hair162 from './cos-img/product-img/products/shampoo/syoss/hair (15).jpg';
import hair163 from './cos-img/product-img/products/shampoo/syoss/hair (16).jpg';
import hair164 from './cos-img/product-img/products/shampoo/syoss/hair (17).jpg';
import hair165 from './cos-img/product-img/products/shampoo/syoss/hair (18).jpg';
import hair166 from './cos-img/product-img/products/shampoo/syoss/hair (19).jpg';
import hair167 from './cos-img/product-img/products/shampoo/syoss/hair (20).jpg';
import hair168 from './cos-img/product-img/products/shampoo/syoss/hair (21).jpg';
import hair169 from './cos-img/product-img/products/shampoo/syoss/hair (22).jpg';
import hair170 from './cos-img/product-img/products/shampoo/syoss/hair (23).jpg';
import hair171 from './cos-img/product-img/products/shampoo/syoss/hair (24).jpg';
import hair172 from './cos-img/product-img/products/shampoo/syoss/hair (25).jpg';
import hair173 from './cos-img/product-img/products/shampoo/syoss/hair (26).jpg';
import hair174 from './cos-img/product-img/products/shampoo/syoss/hair (27).jpg';
import hair175 from './cos-img/product-img/products/shampoo/syoss/hair (28).jpg';
import hair176 from './cos-img/product-img/products/shampoo/syoss/hair (29).jpg';
import hair177 from './cos-img/product-img/products/shampoo/syoss/hair (30).jpg';
import hair178 from './cos-img/product-img/products/shampoo/syoss/hair (31).jpg';

import hair179 from './cos-img/product-img/products/shampoo/head&sholders/hair (1).jpg';
import hair180 from './cos-img/product-img/products/shampoo/head&sholders/hair (2).jpg';
import hair181 from './cos-img/product-img/products/shampoo/head&sholders/hair (3).jpg';
import hair182 from './cos-img/product-img/products/shampoo/head&sholders/hair (4).jpg';
import hair183 from './cos-img/product-img/products/shampoo/head&sholders/hair (5).jpg';
import hair184 from './cos-img/product-img/products/shampoo/head&sholders/hair (6).jpg';
import hair185 from './cos-img/product-img/products/shampoo/head&sholders/hair (7).jpg';
import hair186 from './cos-img/product-img/products/shampoo/head&sholders/hair (8).jpg';
import hair187 from './cos-img/product-img/products/shampoo/head&sholders/hair (9).jpg';
import hair188 from './cos-img/product-img/products/shampoo/head&sholders/hair (10).jpg';
import hair189 from './cos-img/product-img/products/shampoo/head&sholders/hair (11).jpg';
import hair190 from './cos-img/product-img/products/shampoo/head&sholders/hair (12).jpg';
import hair191 from './cos-img/product-img/products/shampoo/head&sholders/hair (13).jpg';
import hair192 from './cos-img/product-img/products/shampoo/head&sholders/hair (14).jpg';
import hair193 from './cos-img/product-img/products/shampoo/head&sholders/hair (15).jpg';
import hair194 from './cos-img/product-img/products/shampoo/head&sholders/hair (16).jpg';
import hair195 from './cos-img/product-img/products/shampoo/head&sholders/hair (17).jpg';
import hair196 from './cos-img/product-img/products/shampoo/head&sholders/hair (18).jpg';
import hair197 from './cos-img/product-img/products/shampoo/head&sholders/hair (19).jpg';
import hair198 from './cos-img/product-img/products/shampoo/head&sholders/hair (20).jpg';
import hair199 from './cos-img/product-img/products/shampoo/head&sholders/hair (21).jpg';
import hair200 from './cos-img/product-img/products/shampoo/head&sholders/hair (22).jpg';
import hair201 from './cos-img/product-img/products/shampoo/head&sholders/hair (23).jpg';
import hair202 from './cos-img/product-img/products/shampoo/head&sholders/hair (24).jpg';
import hair203 from './cos-img/product-img/products/shampoo/head&sholders/hair (25).jpg';
import hair204 from './cos-img/product-img/products/shampoo/head&sholders/hair (26).jpg';
import hair205 from './cos-img/product-img/products/shampoo/head&sholders/hair (27).jpg';
import hair206 from './cos-img/product-img/products/shampoo/head&sholders/hair (28).jpg';
import hair207 from './cos-img/product-img/products/shampoo/head&sholders/hair (29).jpg';
import hair208 from './cos-img/product-img/products/shampoo/head&sholders/hair (30).jpg';
import hair209 from './cos-img/product-img/products/shampoo/head&sholders/hair (31).jpg';
import hair210 from './cos-img/product-img/products/shampoo/head&sholders/hair (32).jpg';
import hair211 from './cos-img/product-img/products/shampoo/head&sholders/hair (33).jpg';
import hair212 from './cos-img/product-img/products/shampoo/head&sholders/hair (34).jpg';
import hair213 from './cos-img/product-img/products/shampoo/head&sholders/hair (35).jpg';
import hair214 from './cos-img/product-img/products/shampoo/head&sholders/hair (36).jpg';
import hair215 from './cos-img/product-img/products/shampoo/head&sholders/hair (37).jpg';
import hair216 from './cos-img/product-img/products/shampoo/head&sholders/hair (38).jpg';
import hair217 from './cos-img/product-img/products/shampoo/head&sholders/hair (39).jpg';
import hair218 from './cos-img/product-img/products/shampoo/head&sholders/hair (40).jpg';
import hair219 from './cos-img/product-img/products/shampoo/head&sholders/hair (41).jpg';
import hair220 from './cos-img/product-img/products/shampoo/head&sholders/hair (42).jpg';



import bodyOne from './cos-img/product-img/products/body/enchanteur/body (1).jpg';
import bodyTwo from './cos-img/product-img/products/body/enchanteur/body (2).jpg';
import bodyThree from './cos-img/product-img/products/body/enchanteur/body (3).jpg';
import bodyFour from './cos-img/product-img/products/body/enchanteur/body (4).jpg';
import bodyFive from './cos-img/product-img/products/body/enchanteur/body (5).jpg';
import bodySix from './cos-img/product-img/products/body/enchanteur/body (6).jpg';
import bodySeven from './cos-img/product-img/products/body/enchanteur/body (7).jpg';
import bodyEight from './cos-img/product-img/products/body/enchanteur/body (8).jpg';
import bodyNine from './cos-img/product-img/products/body/enchanteur/body (9).jpg';
import bodyTen from './cos-img/product-img/products/body/enchanteur/body (10).jpg';
import body11 from './cos-img/product-img/products/body/enchanteur/body (11).jpg';
import body12 from './cos-img/product-img/products/body/enchanteur/body (12).jpg';
import body13 from './cos-img/product-img/products/body/enchanteur/body (13).jpg';
import body14 from './cos-img/product-img/products/body/enchanteur/body (14).jpg';
import body15 from './cos-img/product-img/products/body/enchanteur/body (15).jpg';
import body16 from './cos-img/product-img/products/body/enchanteur/body (16).jpg';
import body17 from './cos-img/product-img/products/body/enchanteur/body (17).jpg';
import body18 from './cos-img/product-img/products/body/enchanteur/body (18).jpg';
import body19 from './cos-img/product-img/products/body/enchanteur/body (19).jpg';
import body20 from './cos-img/product-img/products/body/enchanteur/body (20).jpg';
import body21 from './cos-img/product-img/products/body/enchanteur/body (21).jpg';
import body22 from './cos-img/product-img/products/body/enchanteur/body (22).jpg';
import body23 from './cos-img/product-img/products/body/enchanteur/body (23).jpg';
import body24 from './cos-img/product-img/products/body/enchanteur/body (24).jpg';
import body25 from './cos-img/product-img/products/body/enchanteur/body (25).jpg';

import body26 from './cos-img/product-img/products/body/nevia/body (1).jpg';
import body27 from './cos-img/product-img/products/body/nevia/body (2).jpg';
import body28 from './cos-img/product-img/products/body/nevia/body (3).jpg';
import body29 from './cos-img/product-img/products/body/nevia/body (4).jpg';
import body30 from './cos-img/product-img/products/body/nevia/body (5).jpg';
import body31 from './cos-img/product-img/products/body/nevia/body (6).jpg';
import body32 from './cos-img/product-img/products/body/nevia/body (7).jpg';
import body33 from './cos-img/product-img/products/body/nevia/body (8).jpg';
import body34 from './cos-img/product-img/products/body/nevia/body (9).jpg';
import body35 from './cos-img/product-img/products/body/nevia/body (10).jpg';
import body36 from './cos-img/product-img/products/body/nevia/body (11).jpg';
import body37 from './cos-img/product-img/products/body/nevia/body (12).jpg';
import body38 from './cos-img/product-img/products/body/nevia/body (13).jpg';
import body39 from './cos-img/product-img/products/body/nevia/body (14).jpg';
import body40 from './cos-img/product-img/products/body/nevia/body (15).jpg';
import body41 from './cos-img/product-img/products/body/nevia/body (16).jpg';
import body42 from './cos-img/product-img/products/body/nevia/body (17).jpg';
import body43 from './cos-img/product-img/products/body/nevia/body (18).jpg';
import body44 from './cos-img/product-img/products/body/nevia/body (19).jpg';
import body45 from './cos-img/product-img/products/body/nevia/body (20).jpg';
import body46 from './cos-img/product-img/products/body/nevia/body (21).jpg';
import body47 from './cos-img/product-img/products/body/nevia/body (22).jpg';
import body48 from './cos-img/product-img/products/body/nevia/body (23).jpg';
import body49 from './cos-img/product-img/products/body/nevia/body (24).jpg';
import body50 from './cos-img/product-img/products/body/nevia/body (25).jpg';
import body51 from './cos-img/product-img/products/body/nevia/body (26).jpg';
import body52 from './cos-img/product-img/products/body/nevia/body (27).jpg';
import body53 from './cos-img/product-img/products/body/nevia/body (28).jpg';
import body54 from './cos-img/product-img/products/body/nevia/body (29).jpg';
import body55 from './cos-img/product-img/products/body/nevia/body (30).jpg';
import body56 from './cos-img/product-img/products/body/nevia/body (31).jpg';
import body57 from './cos-img/product-img/products/body/nevia/body (32).jpg';
import body58 from './cos-img/product-img/products/body/nevia/body (33).jpg';
import body59 from './cos-img/product-img/products/body/nevia/body (34).jpg';
import body60 from './cos-img/product-img/products/body/nevia/body (35).jpg';
import body61 from './cos-img/product-img/products/body/nevia/body (36).jpg';
import body62 from './cos-img/product-img/products/body/nevia/body (37).jpg';
import body63 from './cos-img/product-img/products/body/nevia/body (38).jpg';
import body64 from './cos-img/product-img/products/body/nevia/body (39).jpg';
import body65 from './cos-img/product-img/products/body/nevia/body (40).jpg';

import body66 from './cos-img/product-img/products/body/vasline/body (1).jpg';
import body67 from './cos-img/product-img/products/body/vasline/body (2).jpg';
import body68 from './cos-img/product-img/products/body/vasline/body (3).jpg';
import body69 from './cos-img/product-img/products/body/vasline/body (4).jpg';
import body70 from './cos-img/product-img/products/body/vasline/body (5).jpg';
import body71 from './cos-img/product-img/products/body/vasline/body (6).jpg';
import body72 from './cos-img/product-img/products/body/vasline/body (7).jpg';
import body73 from './cos-img/product-img/products/body/vasline/body (8).jpg';
import body74 from './cos-img/product-img/products/body/vasline/body (9).jpg';
import body75 from './cos-img/product-img/products/body/vasline/body (10).jpg';
import body76 from './cos-img/product-img/products/body/vasline/body (11).jpg';
import body77 from './cos-img/product-img/products/body/vasline/body (12).jpg';
import body78 from './cos-img/product-img/products/body/vasline/body (13).jpg';
import body79 from './cos-img/product-img/products/body/vasline/body (14).jpg';
import body80 from './cos-img/product-img/products/body/vasline/body (15).jpg';
import body81 from './cos-img/product-img/products/body/vasline/body (16).jpg';
import body82 from './cos-img/product-img/products/body/vasline/body (17).jpg';
import body83 from './cos-img/product-img/products/body/vasline/body (18).jpg';
import body84 from './cos-img/product-img/products/body/vasline/body (19).jpg';
import body85 from './cos-img/product-img/products/body/vasline/body (20).jpg';
import body86 from './cos-img/product-img/products/body/vasline/body (21).jpg';
import body87 from './cos-img/product-img/products/body/vasline/body (22).jpg';
import body88 from './cos-img/product-img/products/body/vasline/body (23).jpg';
import body89 from './cos-img/product-img/products/body/vasline/body (24).jpg';
import body90 from './cos-img/product-img/products/body/vasline/body (25).jpg';
import body91 from './cos-img/product-img/products/body/vasline/body (26).jpg';
import body92 from './cos-img/product-img/products/body/vasline/body (27).jpg';
import body93 from './cos-img/product-img/products/body/vasline/body (28).jpg';
import body94 from './cos-img/product-img/products/body/vasline/body (29).jpg';
import body95 from './cos-img/product-img/products/body/vasline/body (30).jpg';
import body96 from './cos-img/product-img/products/body/vasline/body (31).jpg';
import body97 from './cos-img/product-img/products/body/vasline/body (32).jpg';

import body98 from './cos-img/product-img/products/body/oe-dove/body (1).jpg';
import body99 from './cos-img/product-img/products/body/oe-dove/body (2).jpg';
import body100 from './cos-img/product-img/products/body/oe-dove/body (3).jpg';
import body101 from './cos-img/product-img/products/body/oe-dove/body (4).jpg';
import body102 from './cos-img/product-img/products/body/oe-dove/body (5).jpg';
import body103 from './cos-img/product-img/products/body/oe-dove/body (6).jpg';
import body104 from './cos-img/product-img/products/body/oe-dove/body (7).jpg';
import body105 from './cos-img/product-img/products/body/oe-dove/body (8).jpg';
import body106 from './cos-img/product-img/products/body/oe-dove/body (9).jpg';
import body107 from './cos-img/product-img/products/body/oe-dove/body (10).jpg';
import body108 from './cos-img/product-img/products/body/oe-dove/body (11).jpg';
import body109 from './cos-img/product-img/products/body/oe-dove/body (12).jpg';
import body110 from './cos-img/product-img/products/body/oe-dove/body (13).jpg';
import body111 from './cos-img/product-img/products/body/oe-dove/body (14).jpg';
import body112 from './cos-img/product-img/products/body/oe-dove/body (15).jpg';
import body113 from './cos-img/product-img/products/body/oe-dove/body (16).jpg';
import body114 from './cos-img/product-img/products/body/oe-dove/body (17).jpg';
import body115 from './cos-img/product-img/products/body/oe-dove/body (18).jpg';
import body116 from './cos-img/product-img/products/body/oe-dove/body (19).jpg';
import body117 from './cos-img/product-img/products/body/oe-dove/body (20).jpg';
import body118 from './cos-img/product-img/products/body/oe-dove/body (21).jpg';
import body119 from './cos-img/product-img/products/body/oe-dove/body (22).jpg';
import body120 from './cos-img/product-img/products/body/oe-dove/body (23).jpg';
import body121 from './cos-img/product-img/products/body/oe-dove/body (24).jpg';
import body122 from './cos-img/product-img/products/body/oe-dove/body (25).jpg';
import body123 from './cos-img/product-img/products/body/oe-dove/body (26).jpg';
import body124 from './cos-img/product-img/products/body/oe-dove/body (27).jpg';
import body125 from './cos-img/product-img/products/body/oe-dove/body (28).jpg';
import body126 from './cos-img/product-img/products/body/oe-dove/body (29).jpg';
import body127 from './cos-img/product-img/products/body/oe-dove/body (30).jpg';
import body128 from './cos-img/product-img/products/body/oe-dove/body (31).jpg';
import body129 from './cos-img/product-img/products/body/oe-dove/body (32).jpg';
import body130 from './cos-img/product-img/products/body/oe-dove/body (33).jpg';
import body131 from './cos-img/product-img/products/body/oe-dove/body (34).jpg';
import body132 from './cos-img/product-img/products/body/oe-dove/body (35).jpg';
import body133 from './cos-img/product-img/products/body/oe-dove/body (36).jpg';
import body134 from './cos-img/product-img/products/body/oe-dove/body (37).jpg';
import body135 from './cos-img/product-img/products/body/oe-dove/body (38).jpg';
import body136 from './cos-img/product-img/products/body/oe-dove/body (39).jpg';
 



import lipOne from './cos-img/product-img/products/makeup/lipStick/lips (7).jpg';


import faceCremeOne from './cos-img/product-img/products/faceCreme/face-creme/creme (2).jpg';
import sunCremeOne from './cos-img/product-img/products/faceCreme/sun-creme/sunCreme (1).jpg';
import sunCremeTwo from './cos-img/product-img/products/faceCreme/sun-creme/sunCreme (2).jpg';
import sunCremeThree from './cos-img/product-img/products/faceCreme/sun-creme/sunCreme (3).jpg';
import sunCremeFour from './cos-img/product-img/products/faceCreme/sun-creme/sunCreme (4).jpg';
import sunCremeFive from './cos-img/product-img/products/faceCreme/sun-creme/sunCreme (5).jpg';
import sunCremeSix from './cos-img/product-img/products/faceCreme/sun-creme/sunCreme (6).jpg';
import sunCremeSeven from './cos-img/product-img/products/faceCreme/sun-creme/sunCreme (7).jpg';
import sunCremeEight from './cos-img/product-img/products/faceCreme/sun-creme/sunCreme (8).jpg';


export const productsList = [
    {
        id: 1,
        period: "new",
        img: faceCremeOne,
        type: "Night creme",
        class: "face creme",
        link: "creme",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "L'OREAL Nutrition Intense, Age perfect cell renewal for everyday use",
        size: "85ml",
        price: 12.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 2,
        period: "try me",
        img: makeupOne,
        type: "Sephora Blusher",
        class: "blusher",
        link: "makeup",
        brand: "sephora",
        target:"woman",
        rank: "new",
        description: "Whether you choose rose or peachy, blush up your cheeks with Sephora",
        size: "30ml",
        price: 6.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 3,
        period: "new",
        img: sunCremeSix,
        type: "sun creme",
        class: "face creme",
        link: "creme",
        brand: "Diasaar",
        target:"woman",
        rank: "new",
        description: "Diasaar sun creme for ultimate protection from the uva and uvb sun light",
        size: "95ml/ 135ml",
        price: 10.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 4,
        period: "grab me",
        img: hairOne,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "ulraDoux shampo avocado oil, argan oil & hony, green tea, flower cotton",
        size: "250ml/ 400ml",
        price: 7.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 5,
        period: "try me",
        img: makeupTwo,
        type: "Hd staurated colors",
        class: "bridal makeUp",
        link: "makeup",
        brand: "everbeuty",
        target:"woman",
        rank: "new",
        description: "3 hot designs and a makeup kit. Comes with a variety of shades",
        size: "15 saturated color",
        price: 18.05,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 6,
        period: "new",
        img: makeupThree,
        type: "Dior Blusher",
        class: "blusher",
        link: "makeup",
        brand: "dior",
        target:"woman",
        rank: "new",
        description: "blush from Dior that gives cheeks intense, ultra-pigmented color that lasts",
        size: "30g / pink/ red/ peach",
        price: 9.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 7,
        period: "try me",
        img: makeupFour,
        type: "Fit me Blusher",
        class: "blusher",
        link: "makeup",
        brand: "fitme",
        target:"woman",
        rank: "new",
        description: "FIT me blush the second colloction of nude colors from FITme",
        size: "20g / ivory / light beige",
        price: 7.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 8,
        period: "new",
        img: lipOne ,
        type: "Doll Lipstick ",
        class: "lipstick",
        link: "makeup",
        brand: "doll",
        target:"woman",
        rank: "new",
        description: "the Doll Beauty lipsticks are versatile, highly pigmented and lightweight",
        size: "7g/ 12 color",
        price: 8.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 9,
        period: "take me",
        img: hairThree,
        type: "shampo & oil repleacement",
        class: "collection",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "popular",
        description: "the new collection from elseve for tinted, or bleached and dry hair with keratin",
        size: "300ml/ 110ml",
        price: 21.90,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 10,
        period: "try me",
        img: hairFour,
        type: "shampo & condtioner",
        class: "collection",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "popular",
        description: "Elseve for tinted hair and coloration for long lasting and shining color",
        size: "350ml / 300ml",
        price: 15.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 11,
        period: "new",
        img: hairFive,
        type: "TRESemme shampo & hairMask",
        class: "collection",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "the ultra shine shampo and hairCreme for dry, damaged and colored hair",
        size: "480ml/ 200ml",
        price: 16.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 12,
        period: "take me",
        img: hairTwo,
        type: "Shampo & oil repleacement",
        class: "collection",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "PROvost shampo condtioner and serum for frizzy, dry and lost colored hair",
        size: "750ml/ 7500ml/ 300ml",
        price: 28.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 13,
        period: "try me",
        img: sunCremeOne,
        type: "sun creme",
        class: "face creme",
        link: "creme",
        brand: "Eucerin",
        target:"woman",
        rank: "new",
        description: "Eucerin the new sunCreme for senstive skin to chellange the sun",
        size: "110ml/50+&90-SPF",
        price: 8.90,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 14,
        period: "new",
        img: sunCremeTwo,
        type: "sun creme",
        class: "face creme",
        link: "creme",
        brand: "Dermagor",
        target:"woman",
        rank: "new",
        description: "the for greasy and all skine type Dermagor sunCreme for vibrating summer",
        size: "110ml/50+&90-SPF",
        price: 10.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 15,
        period: "new",
        img: sunCremeThree,
        type: "sun creme",
        class: "face creme",
        link: "creme",
        brand: "Bonjour",
        target:"woman",
        rank: "new",
        description: "Bonjour for every hot morning to be the last one standing",
        size: "90ml/ 60&90SPF",
        price: 4.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 16,
        period: "try me",
        img: sunCremeFour,
        type: "sun creme",
        class: "face creme",
        link: "creme",
        brand: "Clarins",
        target:"woman",
        rank: "new",
        description: "the ultimate protection from the sun with our new sunCreme for long exposure",
        size: "105ml/ 60&90SPF",
        price: 14.05,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 17,
        period: "take me",
        img: sunCremeFive,
        type: "sun creme",
        class: "face creme",
        link: "creme",
        brand: "Leopard",
        target:"woman",
        rank: "new",
        description: "leopard sunCreme for long lasting sun protection and hydration",
        size: "90ml/ 40&50+SPF",
        price: 7.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 18,
        period: "new",
        img: sunCremeSeven,
        type: "sun creme",
        class: "face creme",
        link: "creme",
        brand: "Attitude",
        target:"kids",
        rank: "new",
        description: "the soft and protective sunCreme for your little angle",
        size: "75ml/ 60&50+&SPF",
        price: 6.95,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 19,
        period: "try me",
        img: sunCremeEight,
        type: "sun creme",
        class: "face creme",
        link: "creme",
        brand: "Attitude",
        target:"woman",
        rank: "new",
        description: "the soft and protective sunCreme with our new Alovera formula",
        size: "95ml/ 60&90&SPF",
        price: 9.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 20,
        period: "new",
        img: hairSix,
        type: "Elseve gold collection",
        class: "collection",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "best-seller",
        description: "the ever eveloving gold hair collection from loreal paris",
        size: "380ml/200ml/150ml",
        price: 32.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 21,
        period: "new",
        img: hairSeven,
        type: "Elseve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the ultra shine shampo for long and dry, damaged and brittle hair",
        size: "380ml",
        price: 7.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 22,
        period: "try me",
        img: hairEight,
        type: "Elseve conditioner",
        class: "conditioner",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the ultra shine conditioner hairCreme for dry, damaged and colored hair",
        size: "380ml",
        price: 5.95,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 23,
        period: "take me",
        img: hairNine,
        type: "Elseve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "elseve hair shampo for dry, ,lost color and long brittle hair",
        size: "380ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 24,
        period: "take me",
        img: hairTen,
        type: "Elsve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 25,
        period: "take me",
        img: hair11,
        type: "Elsve conditioner",
        class: "conditioner",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 26,
        period: "take me",
        img: hair12,
        type: "Elsve OIL",
        class: "conditioner",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 8.70,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 27,
        period: "take me",
        img: hair13,
        type: "Elsve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 9.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 28,
        period: "try me",
        img: hair14,
        type: "Elsve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 9.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 29,
        period: "try me",
        img: hair15,
        type: "Elsve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 9.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 30,
        period: "try me",
        img: hair16,
        type: "Elsve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 11.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 31,
        period: "try me",
        img: hair17,
        type: "Elsve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 9.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 32,
        period: "try me",
        img: hair18,
        type: "Elsve shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 19.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 33,
        period: "try me",
        img: hair19,
        type: "Elsve shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 14.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 34,
        period: "try me",
        img: hair20,
        type: "Elsve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 7.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 35,
        period: "try me",
        img: hair21,
        type: "Elsve shampo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "best seller",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 9.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 36,
        period: "try me",
        img: hair22,
        type: "Elsve hair mask",
        class: "hair mask",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "best seller",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 13.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 37,
        period: "try me",
        img: hair23,
        type: "Elsve shampoo",
        class: "shampoo",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 16.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 38,
        period: "try me",
        img: hair24,
        type: "Elsve hair mask",
        class: "hair mask",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "best seller",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 12.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 39,
        period: "try me",
        img: hair25,
        type: "Elsve hair mask",
        class: "hair mask",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "best seller",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 12.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 40,
        period: "try me",
        img: hair26,
        type: "Elsve shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 16.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 41,
        period: "try me",
        img: hair27,
        type: "Elsve hair mask",
        class: "hair mask",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "best seller",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 10.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 42,
        period: "try me",
        img: hair28,
        type: "Elsve collection",
        class: "collection",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "best seller",
        description: "the old school shampo from elesve for greasy and oily hair",
        size: "380ml",
        price: 35.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 43,
        period: "try me",
        img: hair29,
        type: "Elsve new collection",
        class: "collection",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school shampo & conditioner from elesve for greasy and oily hair",
        size: "380ml",
        price: 38.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 44,
        period: "try me",
        img: hair30,
        type: "Elsve conditioner",
        class: "conditioner",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school conditioner from elesve for greasy and oily hair",
        size: "380ml",
        price: 8.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 45,
        period: "try me",
        img: hair31,
        type: "Elsve conditioner",
        class: "conditioner",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school conditioner from elesve for greasy and oily hair",
        size: "380ml",
        price: 7.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 46,
        period: "try me",
        img: hair32,
        type: "Elsve conditioner",
        class: "conditioner",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school conditioner from elesve for greasy and oily hair",
        size: "380ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 47,
        period: "try me",
        img: hair33,
        type: "Elsve conditioner",
        class: "conditioner",
        link: "hair",
        brand: "loreal",
        target:"woman",
        rank: "new",
        description: "the old school conditioner from elesve for greasy and oily hair",
        size: "380ml",
        price: 8.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 48,
        period: "try me",
        img: hair34,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 49,
        period: "try me",
        img: hair35,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 50,
        period: "try me",
        img: hair36,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 51,
        period: "try me",
        img: hair37,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 8.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 52,
        period: "try me",
        img: hair38,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 53,
        period: "try me",
        img: hair39,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 6.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 54,
        period: "try me",
        img: hair40,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 8.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 55,
        period: "try me",
        img: hair41,
        type: "Garnier shampo conditioner",
        class: "collection",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 12.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 56,
        period: "try me",
        img: hair42,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 57,
        period: "try me",
        img: hair43,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 58,
        period: "try me",
        img: hair44,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 59,
        period: "try me",
        img: hair45,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 60,
        period: "try me",
        img: hair46,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 8.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 61,
        period: "try me",
        img: hair47,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 62,
        period: "try me",
        img: hair48,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 9.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 63,
        period: "try me",
        img: hair49,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 64,
        period: "try me",
        img: hair50,
        type: "Garnier hair mask",
        class: "hair mask",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 65,
        period: "try me",
        img: hair51,
        type: "Garnier hair mask",
        class: "hair mask",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 66,
        period: "try me",
        img: hair52,
        type: "Garnier hair mask",
        class: "hair mask",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 67,
        period: "try me",
        img: hair53,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 68,
        period: "try me",
        img: hair54,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 69,
        period: "try me",
        img: hair55,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 70,
        period: "try me",
        img: hair56,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.05,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 71,
        period: "try me",
        img: hair57,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 8.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 72,
        period: "try me",
        img: hair58,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 73,
        period: "try me",
        img: hair59,
        type: "Garnier conditioner",
        class: "conditioner",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 8.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 74,
        period: "try me",
        img: hair60,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 75,
        period: "try me",
        img: hair61,
        type: "shampo conditioner&creme",
        class: "collection",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 16.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 76,
        period: "try me",
        img: hair62,
        type: "Garnier shampo",
        class: "collection",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 9.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 77,
        period: "try me",
        img: hair63,
        type: "Garnier super Package",
        class: "collection",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 36.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 78,
        period: "try me",
        img: hair64,
        type: "Garnier hair mask",
        class: "hair mask",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 9.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 79,
        period: "try me",
        img: hair65,
        type: "Garnier hair mask",
        class: "hair mask",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 10.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 80,
        period: "try me",
        img: hair66,
        type: "Garnier hair mask",
        class: "hair mask",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 11.05,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 81,
        period: "try me",
        img: hair67,
        type: "Garnier hair mask",
        class: "hair mask",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 9.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 82,
        period: "try me",
        img: hair68,
        type: "Garnier hair mask",
        class: "hair mask",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 9.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 83,
        period: "try me",
        img: hair69,
        type: "Garnier shampo",
        class: "shampoo",
        link: "hair",
        brand: "garnier",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all hair types, dry and damaged from garnier",
        size: "300ml",
        price: 9.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 84,
        period: "try me",
        img: bodyOne,
        type: "enchanteur Talc",
        class: "TALCUM",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "180ml",
        price: 7.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 85,
        period: "try me",
        img: bodyTwo,
        type: "enchanteur shower gel",
        class: "showerGel",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "380ml",
        price: 13.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 86,
        period: "try me",
        img: bodyThree,
        type: "shower gel & lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "350ml/380ml",
        price: 24.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 87,
        period: "try me",
        img: bodyFour,
        type: "enchanteur Talc",
        class: "TALCUM",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 12.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 88,
        period: "try me",
        img: bodyFive,
        type: "enchanteur Talc",
        class: "TALCUM",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "180ml",
        price: 7.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 89,
        period: "try me",
        img: bodySix,
        type: "enchanteur Talc",
        class: "TALCUM",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 12.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 90,
        period: "try me",
        img: bodySeven,
        type: "enchanteur Talc",
        class: "TALCUM",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "200ml",
        price: 8.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 91,
        period: "try me",
        img: bodyEight,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 14.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 92,
        period: "try me",
        img: bodyNine,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "360ml",
        price: 15.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 93,
        period: "try me",
        img: bodyTen,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 13.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 94,
        period: "try me",
        img: body11,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "360ml",
        price: 16.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 95,
        period: "try me",
        img: body12,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "360ml",
        price: 15.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 96,
        period: "try me",
        img: body13,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 13.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 97,
        period: "try me",
        img: body14,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 13.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 98,
        period: "try me",
        img: body15,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "360ml",
        price: 14.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 99,
        period: "try me",
        img: body16,
        type: "enchanteur Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 12.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 100,
        period: "try me",
        img: body17,
        type: "enchanteur Lotion",
        class: "TALCUM",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 12.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 101,
        period: "try me",
        img: body18,
        type: "enchanteur Lotion",
        class: "TALCUM",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "200ml",
        price: 8.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 102,
        period: "try me",
        img: body19,
        type: "enchanteur Lotion",
        class: "TALCUM",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 12.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 103,
        period: "try me",
        img: body20,
        type: "enchanteur showerGel",
        class: "showerGel",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 13.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 104,
        period: "try me",
        img: body21,
        type: "enchanteur showerGel",
        class: "showerGel",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "330ml",
        price: 13.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 105,
        period: "try me",
        img: body22,
        type: "enchanteur showerGel",
        class: "showerGel",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "330ml",
        price: 13.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 106,
        period: "try me",
        img: body23,
        type: "enchanteur showerGel",
        class: "showerGel",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "300ml",
        price: 12.90,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 107,
        period: "try me",
        img: body24,
        type: "enchanteur showerGel",
        class: "showerGel",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "400ml",
        price: 16.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 108,
        period: "try me",
        img: body25,
        type: "enchanteur showerGel",
        class: "showerGel",
        link: "body",
        brand: "enchanteur",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from enchanteur",
        size: "550ml",
        price: 18.70,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 109,
        period: "try me",
        img: body26,
        type: "nivea bodyLotion",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 16.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 110,
        period: "try me",
        img: body27,
        type: "nivea bodyLotion",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 17.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 111,
        period: "try me",
        img: body28,
        type: "nivea Q10 Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 18.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 112,
        period: "try me",
        img: body29,
        type: "nivea lotion Day&Night",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 27.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 113,
        period: "try me",
        img: body30,
        type: "nivea beforeShower",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "350ml",
        price: 18.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 114,
        period: "try me",
        img: body31,
        type: "nivea bodyLotion",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "350ml",
        price: 17.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 115,
        period: "try me",
        img: body32,
        type: "nivea bodyCreme",
        class: "bodyCreme",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 19.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 116,
        period: "try me",
        img: body33,
        type: "nivea bodyCreme",
        class: "bodyCreme",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 20.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 117,
        period: "try me",
        img: body34,
        type: "nivea bodyCreme",
        class: "bodyCreme",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 20.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 118,
        period: "try me",
        img: body35,
        type: "nivea bodyCreme",
        class: "bodyCreme",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 20.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 119,
        period: "try me",
        img: body36,
        type: "nivea bodyCreme",
        class: "bodyCreme",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 14.70,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 120,
        period: "try me",
        img: body37,
        type: "nivea bodyCreme",
        class: "bodyCreme",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 17.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 121,
        period: "try me",
        img: body38,
        type: "nivea bodyCreme",
        class: "bodyCreme",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 17.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 122,
        period: "try me",
        img: body39,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 6.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 123,
        period: "try me",
        img: body40,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 6.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 124,
        period: "try me",
        img: body41,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 6.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 125,
        period: "try me",
        img: body42,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 7.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 126,
        period: "try me",
        img: body43,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 6.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 127,
        period: "try me",
        img: body44,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 6.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 128,
        period: "try me",
        img: body45,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 129,
        period: "try me",
        img: body46,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 130,
        period: "try me",
        img: body47,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 131,
        period: "try me",
        img: body48,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 7.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 132,
        period: "try me",
        img: body49,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "380ml",
        price: 6.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 133,
        period: "try me",
        img: body50,
        type: "nivea showerCreme",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "750ml",
        price: 11.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 134,
        period: "try me",
        img: body51,
        type: "nivea showerCreme",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "750ml",
        price: 11.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 135,
        period: "try me",
        img: body52,
        type: "nivea showerCreme",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "750ml",
        price: 12.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 136,
        period: "try me",
        img: body53,
        type: "nivea showerCreme",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "750ml",
        price: 11.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 137,
        period: "try me",
        img: body54,
        type: "nivea showerCreme",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "750ml",
        price: 11.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 138,
        period: "try me",
        img: body55,
        type: "nivea showerLotion",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "450ml",
        price: 14.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 139,
        period: "try me",
        img: body56,
        type: "nivea showerLotion",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "450ml",
        price: 17.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 140,
        period: "try me",
        img: body57,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "350ml",
        price: 12.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 141,
        period: "try me",
        img: body58,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"man",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "450ml",
        price: 7.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 142,
        period: "try me",
        img: body59,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "350ml",
        price: 6.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 143,
        period: "try me",
        img: body60,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "350ml",
        price: 6.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 144,
        period: "try me",
        img: body61,
        type: "nivea showerGel",
        class: "showerGel",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "350ml",
        price: 7.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 145,
        period: "try me",
        img: body62,
        type: "nivea Body lotion",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "350ml",
        price: 16.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 146,
        period: "try me",
        img: body63,
        type: "nivea Body lotion",
        class: "bodyLotion",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate repair for all skin types, dry and damaged from NIVEA",
        size: "350ml",
        price: 17.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 147,
        period: "try me",
        img: body64,
        type: "nivea Body lotion",
        class: "TALCUM",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate Talcum for all skin types, dry and damaged from NIVEA",
        size: "190ml",
        price: 18.05,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 148,
        period: "try me",
        img: body65,
        type: "nivea Body Talc",
        class: "TALCUM",
        link: "body",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the ultimate TAlCum for all skin types, dry and damaged from NIVEA",
        size: "180ml",
        price: 19.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 149,
        period: "try me",
        img: hair70,
        type: "TRESemme shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "best seller",
        description: "the full repair for dry and damaged from TRESemme for stronger look",
        size: "680ml/650ml",
        price: 24.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 150,
        period: "try me",
        img: hair71,
        type: "TRESemme shampo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "best seller",
        description: "full repair for tinted and bleached hair from TRESemme to long lasting color",
        size: "450ml",
        price: 11.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 151,
        period: "try me",
        img: hair72,
        type: "TRESemme shampo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: "the full repair for tinted and bleached hair from TRESemme to long lasting color",
        size: "380ml",
        price: 9.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 152,
        period: "try me",
        img: hair73,
        type: "TRESemme shampo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: "the full repair for tinted and Dry hair from TRESemme to shine",
        size: "450ml",
        price: 12.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 153,
        period: "try me",
        img: hair74,
        type: "TRESemme shampo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: "the full repair for frizzy and weak hair from TRESemme to stronger hold",
        size: "450ml",
        price: 11.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 154,
        period: "try me",
        img: hair75,
        type: "TRESemme shampo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: "the full repair for frizzy and weak hair from TRESemme to stronger hold",
        size: "330ml",
        price: 10.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 155,
        period: "try me",
        img: hair76,
        type: "TRESemme shampo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "best seller",
        description: "the full repair for frizzy and weak hair from TRESemme to stronger hold",
        size: "700ml",
        price: 15.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 156,
        period: "try me",
        img: hair77,
        type: "TRESemme conditioner",
        class: "conditioner",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "the full repair for lost color, dry tend to fall and brittle hair from TRESemme",
        size: "400ml",
        price: 8.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 157,
        period: "try me",
        img: hair78,
        type: "TRESemme conditioner",
        class: "conditioner",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: "the full repair for lost color, dry tend to fall and brittle hair from TRESemme",
        size: "700ml",
        price: 14.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 158,
        period: "try me",
        img: hair79,
        type: "TRESemme shampoo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "the best for dry, tend to fall and frizzy hair from TRESemme for better days",
        size: "700ml",
        price: 15.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 159,
        period: "try me",
        img: hair80,
        type: "TRESemme shampoo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: " the full repair for lost color, dry tend to fall and brittle hair from TRESemme to stronger hair",
        size: "700ml",
        price: 17.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 160,
        period: "try me",
        img: hair81,
        type: "TRESemme shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: " the full repair for lost color, dry tend to fall and brittle hair from TRESemme",
        size: "450ml/450ml",
        price: 20.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 161,
        period: "try me",
        img: hair82,
        type: "TRESemme shampoo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: " the full repair for lost color, dry tend to fall and dammaged hair from TRESemme",
        size: "650ml",
        price: 16.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 162,
        period: "try me",
        img: hair83,
        type: "TRESemme shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for lost color, bleached and dry hair from TRESemme",
        size: "450ml/450ml",
        price: 18.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 163,
        period: "try me",
        img: hair84,
        type: "TRESemme shampo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: "full cover for lost color, bleached and dry hair with keratine from TRESemme",
        size: "750ml",
        price: 14.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 164,
        period: "try me",
        img: hair85,
        type: "TRESemme shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for lost color, bleached and dry hair with keratine from TRESemme",
        size: "500ml/480ml",
        price: 19.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 165,
        period: "try me",
        img: hair86,
        type: "TRESemme shampoo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "best seller",
        description: "full cover for lost color, bleached and dry hair with keratine from TRESemme",
        size: "850ml",
        price: 15.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 166,
        period: "try me",
        img: hair87,
        type: "TRESemme shampoo",
        class: "shampoo",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "best seller",
        description: "full cover for lost color, bleached and dry hair with keratine from TRESemme",
        size: "400ml",
        price: 10.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 167,
        period: "try me",
        img: hair88,
        type: "TRESemme conditioner",
        class: "conditioner",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for lost color, bleached and dry hair with keratine from TRESemme",
        size: "450ml",
        price: 11.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 168,
        period: "try me",
        img: hair89,
        type: "TRESemme conditioner",
        class: "conditioner",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for lost color, bleached and dry hair with keratine from TRESemme",
        size: "680ml",
        price: 13.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 169,
        period: "try me",
        img: hair90,
        type: "TRESemme conditioner",
        class: "conditioner",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for lost color, bleached and dry hair with keratine from TRESemme",
        size: "450ml",
        price: 10.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 170,
        period: "try me",
        img: hair91,
        type: "TRESemme conditioner",
        class: "conditioner",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for hair fall dry, brittle and dammged hair, free from sulfate. TRESemme ",
        size: "700ml",
        price: 14.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 171,
        period: "try me",
        img: hair92,
        type: "TRESemme conditioner",
        class: "conditioner",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for thin faded, bleached and dry hair with keratine, free of sulfate from TRESemme",
        size: "480ml",
        price: 10.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 172,
        period: "try me",
        img: hair93,
        type: "TRESemme conditioner",
        class: "conditioner",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for thin faded, bleached and dry hair with keratine, free of sulfate from TRESemme",
        size: "680ml",
        price: 13.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 173,
        period: "try me",
        img: hair94,
        type: "TRESemme hair mask",
        class: "hair mask",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for thin faded, bleached and dry hair with keratine, free of sulfate from TRESemme",
        size: "180ml",
        price: 16.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 174,
        period: "try me",
        img: hair95,
        type: "TRESemme hair mask",
        class: "hair mask",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "popular",
        description: "full cover for thin faded, bleached and dry hair with keratine, free of sulfate from TRESemme",
        size: "220ml",
        price: 14.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 175,
        period: "try me",
        img: hair96,
        type: "TRESemme hair mask",
        class: "hair mask",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "best seller",
        description: "full cover for  bleached and dry hair with keratine, free of sulfate from TRESemme",
        size: "200ml",
        price: 14.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 176,
        period: "try me",
        img: hair97,
        type: "TRESemme hair mask",
        class: "hair mask",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "new",
        description: "full cover for thin oily, bleached and dry hair with keratine, free of sulfate from TRESemme",
        size: "200ml",
        price: 17.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 177,
        period: "try me",
        img: hair98,
        type: "TRESemme hair mask",
        class: "hair mask",
        link: "hair",
        brand: "tresemme",
        target:"woman",
        rank: "best seller",
        description: "full cover for brittle, frizzy and dry hair with keratine from TRESemme",
        size: "200ml",
        price: 17.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 178,
        period: "try me",
        img: hair99,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "recovery shampoo with essenial oils for tinted, dry and thin hair from NIVEA",
        size: "320ml",
        price: 11.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 179,
        period: "try me",
        img: hair100,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "cleaning shampoo with 7 essenial fibers for tinted, dry and thin hair from NIVEA",
        size: "320ml",
        price: 10.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 180,
        period: "try me",
        img: hair101,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the best shampoo with most repair for oily and brittle hair from NIVEA",
        size: "320ml",
        price: 10.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 181,
        period: "try me",
        img: hair102,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "the best shampoo with most repair for mixed and brittle hair from NIVEA",
        size: "320ml",
        price: 12.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 182,
        period: "try me",
        img: hair103,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "full repair and volume shampoo with argan oil for thick hair from NIVEA",
        size: "320ml",
        price: 12.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 183,
        period: "try me",
        img: hair104,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "daily repair and cleaning shampoo with cotton for silky hair from NIVEA",
        size: "320ml",
        price: 12.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 184,
        period: "try me",
        img: hair105,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "daily repair and cleaning shampoo with cotton for silky hair from NIVEA",
        size: "320ml",
        price: 11.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 185,
        period: "try me",
        img: hair106,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "natural shine and glimmering shampoo with cotton for long and healthy hair from NIVEA",
        size: "320ml",
        price: 13.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 186,
        period: "try me",
        img: hair107,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "natural shine and glimmering shampoo with cotton for long and healthy hair from NIVEA",
        size: "320ml",
        price: 12.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 187,
        period: "try me",
        img: hair108,
        type: "NIVEA shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "full and healthy hair shampoo with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 12.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 188,
        period: "try me",
        img: hair109,
        type: "NIVEA man shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "deep and healthy hair shampoo with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 10.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 189,
        period: "try me",
        img: hair110,
        type: "NIVEA man shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"man",
        rank: "popular",
        description: "full and healthy hair shampoo with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 10.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 190,
        period: "try me",
        img: hair111,
        type: "NIVEA man shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "active and healthy hair shampoo with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 10.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 191,
        period: "try me",
        img: hair112,
        type: "NIVEA man shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"man",
        rank: "best seller",
        description: "Strong and healthy hair shampoo with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 10.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 192,
        period: "try me",
        img: hair113,
        type: "NIVEA man shampoo",
        class: "shampoo",
        link: "hair",
        brand: "nivea",
        target:"man",
        rank: "new",
        description: "cool fresh shampoo with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 11.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 193,
        period: "try me",
        img: hair114,
        type: "NIVEA conditioner",
        class: "conditioner",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "fresh conditioner with alovera for long and healthy hair from NIVEA to shine",
        size: "320ml",
        price: 12.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 194,
        period: "try me",
        img: hair115,
        type: "NIVEA conditioner",
        class: "conditioner",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "healthy and silky hair with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 11.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 195,
        period: "try me",
        img: hair116,
        type: "NIVEA conditioner",
        class: "conditioner",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "cool musk conditioner with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 11.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 196,
        period: "try me",
        img: hair117,
        type: "NIVEA conditioner",
        class: "conditioner",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "natural shine conditioner with alovera for long and healthy hair from NIVEA",
        size: "320ml",
        price: 11.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 197,
        period: "try me",
        img: hair118,
        type: "NIVEA shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "natural shine with alovera for long and healthy hair from NIVEA to healthy sculp",
        size: "320ml/320ml",
        price: 19.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 198,
        period: "try me",
        img: hair119,
        type: "NIVEA shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "new",
        description: "for long and thick with alovera for long and healthy hair from NIVEA",
        size: "320ml/320ml/150ml",
        price: 25.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 199,
        period: "try me",
        img: hair120,
        type: "NIVEA shampoo",
        class: "collection",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "popular",
        description: "for long and thick with alovera for long and healthy hair from NIVEA",
        size: "320ml/320ml",
        price: 17.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 200,
        period: "try me",
        img: hair121,
        type: "NIVEA shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "for long and thick with alovera for long and healthy hair from NIVEA",
        size: "320ml/320ml",
        price: 18.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 201,
        period: "try me",
        img: hair122,
        type: "NIVEA hair mask",
        class: "hair mask",
        link: "hair",
        brand: "nivea",
        target:"woman",
        rank: "best seller",
        description: "for long and thick with alovera for long and healthy hair from NIVEA",
        size: "250ml",
        price: 13.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 202,
        period: "try me",
        img: hair123,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "detox long and thick hair with alovera for healthy hair from PROvost",
        size: "750ml",
        price: 12.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 203,
        period: "try me",
        img: hair124,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Expert Volume and thick hair with agran oil & telsim for healthy hair from PROvost",
        size: "750ml",
        price: 13.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 204,
        period: "try me",
        img: hair125,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "popular",
        description: "hydrant for thin hair with agran oil & alovera for healthy hair from PROvost",
        size: "750ml",
        price: 14.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 205,
        period: "try me",
        img: hair126,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "popular",
        description: "hydrant for thin hair with agran oil & alovera for healthy hair from PROvost",
        size: "750ml",
        price: 13.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 206,
        period: "try me",
        img: hair127,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "hydrant for thin hair with agran oil & alovera for healthy hair from PROvost",
        size: "750ml",
        price: 14.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 207,
        period: "try me",
        img: hair128,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "volume Expert for colored hair with agran oil & snake oils for healthy hair from PROvost",
        size: "750ml",
        price: 15.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 208,
        period: "try me",
        img: hair129,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "for dry , brittle hair with agran oil & taluim for healthy hair from PROvost",
        size: "750ml",
        price: 13.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 209,
        period: "try me",
        img: hair130,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Repair Expert with 10 essential oil & cactus for healthy hair from PROvost",
        size: "750ml",
        price: 15.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 210,
        period: "try me",
        img: hair131,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Color Expert with 5 essential oils, citrus & almond oil for healthy hair from PROvost",
        size: "750ml",
        price: 17.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 211,
        period: "try me",
        img: hair132,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Ex-cell with 5 essential oils, citrus & almond oil for healthy hair from PROvost",
        size: "750ml",
        price: 16.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 212,
        period: "try me",
        img: hair133,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Nutrition Expert for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "750ml",
        price: 14.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 213,
        period: "try me",
        img: hair134,
        type: "PROvost conditioner",
        class: "conditioner",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Hydrant Expert for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "750ml",
        price: 13.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 214,
        period: "try me",
        img: hair135,
        type: "PROvost conditioner",
        class: "conditioner",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "best seller",
        description: "Expert Nutrition for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "750ml",
        price: 14.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 215,
        period: "try me",
        img: hair136,
        type: "PROvost conditioner",
        class: "conditioner",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "popular",
        description: "Nutrition Expert for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "750ml",
        price: 14.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 216,
        period: "try me",
        img: hair137,
        type: "PROvost conditioner",
        class: "conditioner",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Nutrition Expert for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "750ml",
        price: 15.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 217,
        period: "try me",
        img: hair138,
        type: "PROvost conditioner",
        class: "conditioner",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "popular",
        description: "Expert Shine for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "750ml",
        price: 12.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 218,
        period: "try me",
        img: hair139,
        type: "PROvost conditioner",
        class: "conditioner",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Color Expert Shine for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "750ml",
        price: 16.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 219,
        period: "try me",
        img: hair140,
        type: "PROvost shampoo",
        class: "shampoo",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "New Expert diomond for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "580ml",
        price: 18.70,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 220,
        period: "try me",
        img: hair141,
        type: "PROvost hair mask",
        class: "hair mask",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Expert diomond for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "400ml",
        price: 15.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 221,
        period: "try me",
        img: hair142,
        type: "PROvost hair mask",
        class: "hair mask",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "best seller",
        description: "Repair Expert for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "400ml",
        price: 13.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 222,
        period: "try me",
        img: hair143,
        type: "PROvost hair mask",
        class: "hair mask",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "COLOR Expert for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "400ml",
        price: 14.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 223,
        period: "try me",
        img: hair144,
        type: "PROvost hair mask",
        class: "hair mask",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "popular",
        description: "Nutrition & ex-cellular Expert for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "400ml",
        price: 16.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 224,
        period: "try me",
        img: hair145,
        type: "PROvost collection",
        class: "collection",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Nutrition & ex-cellular Expert for all hair types with almond oil & cactus for healthy hair from PROvost",
        size: "750ml/750ml/380ml",
        price: 25.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 225,
        period: "try me",
        img: hair146,
        type: "PROvost shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "best seller",
        description: "Repair Expert for all dry, brittle with almond oil & cactus for healthy hair from PROvost",
        size: "750ml/750ml/",
        price: 23.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 226,
        period: "try me",
        img: hair147,
        type: "PROvost shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "provost",
        target:"woman",
        rank: "new",
        description: "Expert ex Cellular for all dry, brittle with almond oil & argan oil for healthy hair from PROvost",
        size: "750ml/750ml",
        price: 22.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 227,
        period: "try me",
        img: hair148,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "Oleo-21 ex Cellular for all dry, brittle with almond oil & argan oil for healthy hair from SYOSS",
        size: "500ml",
        price: 9.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 228,
        period: "try me",
        img: hair149,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "VOLUME for all thick and healthy hair with snake oil & avocado for healthy hair from SYOSS",
        size: "500ml",
        price: 11.05,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 229,
        period: "try me",
        img: hair150,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "best seller",
        description: "HUILE for all hair type dry and tend to fall with 10 essential oils for healthy hair from SYOSS",
        size: "500ml",
        price: 12.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 230,
        period: "try me",
        img: hair151,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "for Colored hair and dry, tend to be fragile with the essential oils for healthy hair from SYOSS",
        size: "500ml",
        price: 11.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 231,
        period: "try me",
        img: hair152,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "RENEWAL 7 for brittle hair and dry, with the essential oils for healthy hair from SYOSS",
        size: "500ml",
        price: 13.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 232,
        period: "try me",
        img: hair153,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "bset seller",
        description: "Keratine for dry hair and dammaged with the 3 essential oils for healthy hair from SYOSS",
        size: "500ml",
        price: 15.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 233,
        period: "try me",
        img: hair154,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "SALON EX for dry hair and dammaged with the 3 essential oils for healthy hair from SYOSS",
        size: "500ml",
        price: 14.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 234,
        period: "try me",
        img: hair155,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "MOISTURE for brittle, dry hair and dammaged with the almond oil & tail horse oil for healthy hair from SYOSS",
        size: "500ml",
        price: 13.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 235,
        period: "try me",
        img: hair156,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "MOISTURE for brittle, dry hair and dammaged with the almond oil & tail horse oil for healthy hair from SYOSS",
        size: "500ml",
        price: 12.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 236,
        period: "try me",
        img: hair157,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "SHINE for lost color, dry hair and dammaged with the almond oil & tail horse oil for healthy hair from SYOSS",
        size: "500ml",
        price: 13.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 237,
        period: "try me",
        img: hair158,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "for tinted, bleached and dry hair with the almond oil & tail horse oil for healthy hair from SYOSS",
        size: "500ml",
        price: 10.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 238,
        period: "try me",
        img: hair159,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "for hair Fall and brittle hair with onion oil and cactus oil for healthy hair from SYOSS",
        size: "500ml",
        price: 11.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 239,
        period: "try me",
        img: hair160,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popluar",
        description: "Anti Dundruff and faded hair with almond oil and cactus oil for healthy hair from SYOSS",
        size: "500ml",
        price: 12.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 240,
        period: "try me",
        img: hair161,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"man",
        rank: "new",
        description: "Power fresh shampo for all hair types with almond oil and cactus oil for healthy hair from SYOSS",
        size: "500ml",
        price: 12.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 241,
        period: "try me",
        img: hair162,
        type: "SYOSS shampoo",
        class: "shampoo",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "best seller",
        description: "CER%MI shampo for all hair types with almond oil and cactus oil for healthy hair from SYOSS",
        size: "500ml",
        price: 13.70,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 242,
        period: "try me",
        img: hair163,
        type: "SYOSS conditioner",
        class: "conditioner",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "SHINE for all hair types with almond oil and cactus oil for healthy hair from SYOSS",
        size: "500ml",
        price: 12.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 243,
        period: "try me",
        img: hair164,
        type: "SYOSS conditioner",
        class: "conditioner",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "KERATINE for dry, brittle and dmmaged hair with almond oil and keratine for healthy hair from SYOSS",
        size: "500ml",
        price: 12.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 244,
        period: "try me",
        img: hair165,
        type: "SYOSS conditioner",
        class: "conditioner",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "best seller",
        description: "for Colored, blecahed and dry dmmaged hair with almond oil and keratine for healthy hair from SYOSS",
        size: "500ml",
        price: 13.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 245,
        period: "try me",
        img: hair166,
        type: "SYOSS conditioner",
        class: "conditioner",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "SALON EX for blecahed and dry dmmaged hair with 10 essentials oil and keratine for healthy hair from SYOSS",
        size: "500ml",
        price: 14.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 246,
        period: "try me",
        img: hair167,
        type: "SYOSS conditioner",
        class: "conditioner",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "PURE & CARE for normal hair with the essentials oils and argan oil for healthy hair from SYOSS",
        size: "500ml",
        price: 11.90,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 247,
        period: "try me",
        img: hair168,
        type: "SYOSS conditioner",
        class: "conditioner",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "CRAMIODE for normal hair with the 3 essentials oils and argan oil for healthy hair from SYOSS",
        size: "500ml",
        price: 10.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 248,
        period: "try me",
        img: hair169,
        type: "SYOSS conditioner",
        class: "conditioner",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "REPAIR for dry brtille hair with the 7 essentials oils and argan oil for healthy hair from SYOSS",
        size: "500ml",
        price: 13.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 249,
        period: "try me",
        img: hair170,
        type: "SYOSS hair mask",
        class: "hair mask",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "best seller",
        description: "Celular for dry brtille hair with the 7 essentials oils and argan oil for healthy hair from SYOSS",
        size: "220ml",
        price: 15.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 250,
        period: "try me",
        img: hair171,
        type: "SYOSS hair mask",
        class: "hair mask",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "SALON EX for dry brtille hair with the 7 essentials oils and argan oil for healthy hair from SYOSS",
        size: "200ml",
        price: 14.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 251,
        period: "try me",
        img: hair172,
        type: "SYOSS hair mask",
        class: "hair mask",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "best seller",
        description: "REPAIR for dry brtille hair with the 7 essentials oils and argan oil for healthy hair from SYOSS",
        size: "200ml",
        price: 13.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 252,
        period: "try me",
        img: hair173,
        type: "SYOSS hair mask",
        class: "hair mask",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "for Color dry brtille, and bleached hair with the vitamines and argan oil for healthy hair from SYOSS",
        size: "200ml",
        price: 13.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 253,
        period: "try me",
        img: hair174,
        type: "SYOSS hair mask",
        class: "hair mask",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "new Repair Shine for dmmaged hair with the vitamines and argan oil for healthy hair from SYOSS",
        size: "200ml",
        price: 15.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 254,
        period: "try me",
        img: hair175,
        type: "SYOSS shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "popular",
        description: "Repair for dmmaged, and bleached hair with the vitamines and argan oil for healthy hair from SYOSS",
        size: "500ml/500ml",
        price: 24.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 255,
        period: "try me",
        img: hair176,
        type: "SYOSS shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "SALON EX for dry, brittle and colored hair with the almond oil and argan oil for healthy hair from SYOSS",
        size: "500ml/500ml",
        price: 26.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 256,
        period: "try me",
        img: hair177,
        type: "SYOSS shampo & conditioner",
        class: "collection",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "KERATINE for dry, brittle and colored hair with the almond oil and argan oil for healthy hair from SYOSS",
        size: "500ml/500ml",
        price: 25.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 257,
        period: "try me",
        img: hair178,
        type: "SYOSS collection",
        class: "collection",
        link: "hair",
        brand: "syoss",
        target:"woman",
        rank: "new",
        description: "REPAIR for dry, brittle and colored hair with the almond oil and argan oil for healthy hair from SYOSS",
        size: "500ml/500ml/250ml",
        price: 31.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 258,
        period: "try me",
        img: hair179,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "CLASSIC for dunDrruff & silky hair with citrus & argan oil for healthy hair from head&sholders",
        size: "400ml",
        price: 15.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 259,
        period: "try me",
        img: hair180,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "2en1 CLASSIC for dunDrruff & silky hair with citrus & argan oil for healthy hair from head&sholders",
        size: "400ml",
        price: 14.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 260,
        period: "try me",
        img: hair181,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "LEMON for dunDrruff & oily hair with citrus, teluim & cactus for healthy hair from head&sholders",
        size: "400ml",
        price: 16.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 261,
        period: "try me",
        img: hair182,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "Anti hair fall for dunDrruff & oily hair with citrus, teluim & cactus for healthy hair from head&sholders",
        size: "400ml",
        price: 17.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 262,
        period: "try me",
        img: hair183,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "CACTUS & mint for dunDrruff & dry hair with cactus & teluim for healthy hair from head&sholders",
        size: "400ml",
        price: 13.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 263,
        period: "try me",
        img: hair184,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "LISS & silk for dunDrruff & dry hair with cactus, teluim & cactus for healthy hair from head&sholders",
        size: "400ml",
        price: 15.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 264,
        period: "try me",
        img: hair185,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "CALMING LAVENDER for dunDrruff & dry hair with lavender, teluim for healthy hair from head&sholders",
        size: "400ml",
        price: 18.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 265,
        period: "try me",
        img: hair186,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "ALMODNS for dunDrruff & dry hair with lavender, teluim & cactus for healthy hair from head&sholders",
        size: "400ml",
        price: 16.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 266,
        period: "try me",
        img: hair187,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "FRESH MINT for dunDrruff & dry hair with mint, teluim & cactus for healthy hair from head&sholders",
        size: "400ml",
        price: 15.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 267,
        period: "try me",
        img: hair188,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "FRESH MINT for dunDrruff & dry hair with mint, teluim & cactus for healthy hair from head&sholders",
        size: "250ml",
        price: 7.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 268,
        period: "try me",
        img: hair189,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "diamond kurnel for dunDrruff & dry hair with cactus for healthy hair from head&sholders",
        size: "250ml",
        price: 8.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 269,
        period: "try me",
        img: hair190,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "CACTUS & mint for dunDrruff & dry hair with cactus for healthy hair from head&sholders",
        size: "250ml",
        price: 7.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 270,
        period: "try me",
        img: hair191,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "LEMON & citrus for dunDrruff & oily hair with citrus for healthy hair from head&sholders",
        size: "250ml",
        price: 8.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 271,
        period: "try me",
        img: hair192,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "ALOMONDS for dunDrruff & dry & brittle hair with citrus for healthy hair from head&sholders",
        size: "250ml",
        price: 9.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 272,
        period: "try me",
        img: hair193,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"man",
        rank: "popular",
        description: "MAN for dunDrruff & dry & brittle hair with almond oil for healthy hair from head&sholders",
        size: "250ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 273,
        period: "try me",
        img: hair194,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "CLASSIC for dunDrruff & dry & brittle hair with almond oil for healthy hair from head&sholders",
        size: "250ml",
        price: 8.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 274,
        period: "try me",
        img: hair195,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "LISS & slik for dunDrruff & dry & brittle hair with almond oil for healthy hair from head&sholders",
        size: "250ml",
        price: 9.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 275,
        period: "try me",
        img: hair196,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "Honey for dunDrruff & dry & brittle hair with almond oil for healthy hair from head&sholders",
        size: "250ml",
        price: 7.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 276,
        period: "try me",
        img: hair197,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "DIMOMD kurnel for dunDrruff & brittle hair with almond oil for healthy hair from head&sholders",
        size: "250ml",
        price: 8.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 277,
        period: "try me",
        img: hair198,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "ALMOND for dunDrruff dry & brittle hair with almond oil for healthy hair from head&sholders",
        size: "750ml",
        price: 24.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 278,
        period: "try me",
        img: hair199,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "the new Apple and mint fussion shampoo for dunDrruff oily & tend to fall from head&sholders",
        size: "750ml",
        price: 26.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 279,
        period: "try me",
        img: hair200,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "CLASSIC is now in the biggest form for dunDrruff dry, brittle hair from head&sholders",
        size: "750ml",
        price: 25.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 280,
        period: "try me",
        img: hair201,
        type: "head&sholders shampoo",
        class: "shampoo",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "MINT is now in the biggest form for dunDrruff oily & itchy brittle hair from head&sholders",
        size: "750ml",
        price: 28.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 281,
        period: "try me",
        img: hair202,
        type: "head&sholders conditioner",
        class: "conditioner",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "CLASSIC conditioner is out now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "300ml",
        price: 10.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 282,
        period: "try me",
        img: hair203,
        type: "head&sholders conditioner",
        class: "conditioner",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "Mint conditioner is out now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "300ml",
        price: 13.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 283,
        period: "try me",
        img: hair204,
        type: "head&sholders conditioner",
        class: "conditioner",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "SILK & shine conditioner is out now for dunDrruff dry & itchy brittle hair from head&sholders",
        size: "300ml",
        price: 11.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 284,
        period: "try me",
        img: hair205,
        type: "head&sholders conditioner",
        class: "conditioner",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "LEMON & citrus conditioner is out now for dunDrruff oily & itchy brittle hair from head&sholders",
        size: "300ml",
        price: 12.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 285,
        period: "try me",
        img: hair206,
        type: "head&sholders conditioner",
        class: "conditioner",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "Honey conditioner is avalible now for dunDrruff oily & itchy brittle hair from head&sholders",
        size: "300ml",
        price: 12.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 286,
        period: "try me",
        img: hair207,
        type: "head&sholders conditioner",
        class: "conditioner",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "ALMOND conditioner is avalible now for dunDrruff oily & itchy brittle hair from head&sholders",
        size: "300ml",
        price: 13.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 287,
        period: "try me",
        img: hair208,
        type: "head&sholders hair mask",
        class: "hair mask",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "Honey hair mask is avalible now for dunDrruff dammaged & itchy brittle hair from head&sholders",
        size: "350ml",
        price: 14.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 288,
        period: "try me",
        img: hair209,
        type: "head&sholders hair mask",
        class: "hair mask",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "mint & cactus mask is avalible now for dunDrruff dammaged & itchy brittle hair from head&sholders",
        size: "350ml",
        price: 15.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 289,
        period: "try me",
        img: hair210,
        type: "head&sholders oil replacement",
        class: "hair mask",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "oil Replacement is avalible now for dunDrruff dammaged & itchy brittle hair from head&sholders",
        size: "320ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 290,
        period: "try me",
        img: hair211,
        type: "head&sholders oil replacement",
        class: "hair mask",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "Mint oil Replacement is avalible now for dunDrruff dammaged & itchy brittle hair from head&sholders",
        size: "320ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 291,
        period: "try me",
        img: hair212,
        type: "head&sholders oil replacement",
        class: "hair mask",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "almond oil Replacement is avalible now for dunDrruff dammaged & itchy brittle hair from head&sholders",
        size: "320ml",
        price: 7.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 292,
        period: "try me",
        img: hair213,
        type: "head&sholders hair mask",
        class: "hair mask",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "SILK hair mask is avalible now for dunDrruff dammaged & itchy brittle hair from head&sholders",
        size: "350ml",
        price: 13.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 293,
        period: "try me",
        img: hair214,
        type: "head&sholders collection",
        class: "collection",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "popular",
        description: "mint & apple collection is avalible now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "750ml/400ml/250ml",
        price: 37.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 294,
        period: "try me",
        img: hair215,
        type: "head&sholders collection",
        class: "collection",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "COCONUT oil collection is avalible now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "400ml/400ml",
        price: 34.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 295,
        period: "try me",
        img: hair216,
        type: "head&sholders collection",
        class: "collection",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "SUPREME collection is avalible now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "400ml/350ml",
        price: 33.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 296,
        period: "try me",
        img: hair217,
        type: "head&sholders collection",
        class: "collection",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "SILK collection is avalible now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "400ml/350ml",
        price: 30.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 297,
        period: "try me",
        img: hair218,
        type: "head&sholders collection",
        class: "collection",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "new",
        description: "SILK collection is avalible now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "400ml/300ml",
        price: 35.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 298,
        period: "try me",
        img: hair219,
        type: "head&sholders collection",
        class: "collection",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "CLASSIC collection is avalible now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "400ml/300ml",
        price: 34.70,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 299,
        period: "try me",
        img: hair220,
        type: "head&sholders collection",
        class: "collection",
        link: "hair",
        brand: "H&sholders",
        target:"woman",
        rank: "best seller",
        description: "LEMON & citrus collection is avalible now for dunDrruff normal & itchy brittle hair from head&sholders",
        size: "400ml/300ml",
        price: 32.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 300,
        period: "try me",
        img: body66,
        type: "VASELINE shower gel",
        class: "showerGel",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "the Vaseline shower gel for feeling hydrated all day long. The easy-to-spread moisture the best",
        size: "250ml",
        price: 6.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 301,
        period: "try me",
        img: body67,
        type: "VASELINE shower gel",
        class: "showerGel",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "the Vaseline shower gel for feeling hydrated all day long. The easy-to-spread moisture the best",
        size: "250ml",
        price: 8.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 302,
        period: "try me",
        img: body68,
        type: "VASELINE shower gel",
        class: "showerGel",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "best seller",
        description: "the Vaseline shower gel for feeling hydrated all day long. The easy-to-spread moisture the best",
        size: "480ml",
        price: 14.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 303,
        period: "try me",
        img: body69,
        type: "VASELINE shower gel",
        class: "showerGel",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "the Vaseline shower gel for feeling hydrated all day long. The easy-to-spread moisture the best",
        size: "350ml",
        price: 12.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 304,
        period: "try me",
        img: body70,
        type: "VASELINE shower gel",
        class: "showerGel",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "the Vaseline shower gel for feeling hydrated all day long. The easy-to-spread moisture the best",
        size: "300ml",
        price: 9.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 305,
        period: "try me",
        img: body71,
        type: "VASELINE shower gel",
        class: "showerGel",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "the Vaseline shower gel for feeling hydrated all day long. The easy-to-spread moisture the best",
        size: "300ml",
        price: 8.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 306,
        period: "try me",
        img: body72,
        type: "VASELINE shower gel",
        class: "showerGel",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "the Vaseline shower gel for feeling hydrated all day long. The easy-to-spread moisture the best",
        size: "200ml",
        price: 5.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 307,
        period: "try me",
        img: body73,
        type: "VASELINE shower gel",
        class: "showerGel",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "the Vaseline shower gel for feeling hydrated all day long. The easy-to-spread moisture the best",
        size: "400ml",
        price: 10.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 308,
        period: "try me",
        img: body74,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "best seller",
        description: "Vaseline body Lotion for feeling hydrated all day long. The best & easy to spread the moisture ",
        size: "250ml",
        price: 8.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 309,
        period: "try me",
        img: body75,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "Vaseline body Lotion for feeling hydrated all day long. The best & easy to spread the moisture ",
        size: "250ml",
        price: 7.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 310,
        period: "try me",
        img: body76,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "Vaseline body Lotion for feeling hydrated all day long. The best & easy to spread the moisture ",
        size: "250ml",
        price: 6.90,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 311,
        period: "try me",
        img: body77,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "Vaseline body Lotion for feeling hydrated all day long. The best & easy to spread the moisture ",
        size: "200ml",
        price: 8.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 312,
        period: "try me",
        img: body78,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "Vaseline body Lotion for feeling hydrated all day long. with the highest moisturizing percentage",
        size: "400ml",
        price: 12.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 313,
        period: "try me",
        img: body79,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "Vaseline body Lotion for feeling hydrated all day long. with the highest moisturizing percentage",
        size: "400ml",
        price: 13.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 314,
        period: "try me",
        img: body80,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "Vaseline body Lotion for feeling hydrated all day long. with the highest moisturizing percentage",
        size: "400ml",
        price: 14.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 315,
        period: "try me",
        img: body81,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "B3 Vaseline body Lotion for feeling hydrated all day long. with the highest moisturizing percentage",
        size: "400ml",
        price: 15.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 316,
        period: "try me",
        img: body82,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "Vaseline body Lotion for feeling hydrated all day long. with the highest moisturizing percentage",
        size: "750ml",
        price: 18.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 317,
        period: "try me",
        img: body83,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "best seller",
        description: "Vaseline body Lotion for feeling hydrated all day long. with the highest moisturizing percentage",
        size: "750ml",
        price: 19.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 318,
        period: "try me",
        img: body84,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "Vaseline body Lotion for feeling hydrated all day long. with the highest moisturizing percentage",
        size: "750ml",
        price: 20.15,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 319,
        period: "try me",
        img: body85,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "Vaseline body Lotion for feeling hydrated all day long. with the highest moisturizing percentage",
        size: "750ml",
        price: 21.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 320,
        period: "try me",
        img: body86,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "body creme for feeling hydrated all day long. it's super hydrating and great for dry winter",
        size: "85ml",
        price: 5.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 321,
        period: "try me",
        img: body87,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "Body Creme Vaseline for feeling hydrated all day long. that it helps prevent breakouts",
        size: "115ml",
        price: 6.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 322,
        period: "try me",
        img: body88,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "Body Creme Vaseline for feeling hydrated all day long. that it helps prevent breakouts",
        size: "50ml",
        price: 5.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 323,
        period: "try me",
        img: body89,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "Body Creme Vaseline for feeling hydrated all day long. that it helps prevent dehydration",
        size: "45ml",
        price: 4.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 324,
        period: "try me",
        img: body90,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "makes skin feel instantly nourished and pampered without the overly-sticky feeling",
        size: "50ml",
        price: 5.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 325,
        period: "try me",
        img: body91,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "makes skin feel instantly nourished and pampered without the overly-sticky feeling",
        size: "50ml",
        price: 5.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 326,
        period: "try me",
        img: body92,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "best seller",
        description: "makes skin feel instantly nourished and pampered without the overly-sticky feeling",
        size: "50ml",
        price: 6.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 327,
        period: "try me",
        img: body93,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "makes skin feel instantly nourished and pampered without the overly-sticky feeling",
        size: "50ml",
        price: 7.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 328,
        period: "try me",
        img: body94,
        type: "VASELINE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "new",
        description: "makes skin feel instantly nourished and pampered without the overly-sticky feeling",
        size: "50ml",
        price: 6.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 329,
        period: "try me",
        img: body95,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "makes skin feel instantly nourished and pampered without the overly-sticky feeling",
        size: "400ml/450ml",
        price: 25.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 330,
        period: "try me",
        img: body96,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "makes skin feel instantly nourished and pampered without the overly-sticky feeling",
        size: "300ml/450ml/150ml/190ml",
        price: 36.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 331,
        period: "try me",
        img: body97,
        type: "VASELINE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "vaseline",
        target:"woman",
        rank: "popular",
        description: "makes skin feel instantly nourished and pampered without the overly-sticky feeling",
        size: "400ml/450ml",
        price: 27.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 332,
        period: "try me",
        img: body98,
        type: "OE TALCUM",
        class: "TALCUM",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "TALCum from OE, its ability to absorb moisture and provide lubrication at the same time",
        size: "150ml",
        price: 7.20,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 333,
        period: "try me",
        img: body99,
        type: "Dove TALCUM",
        class: "TALCUM",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "TALCum from OE, its ability to absorb moisture and provide lubrication at the same time",
        size: "150ml",
        price: 10.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 334,
        period: "try me",
        img: body100,
        type: "OE TALCUM",
        class: "TALCUM",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "best seller",
        description: "TALCum from OE, its ability to absorb moisture and provide lubrication at the same time",
        size: "150ml",
        price: 8.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 335,
        period: "try me",
        img: body101,
        type: "OE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "coconut clean and care for the body. Enriched in minerals recognized for their revitalizing properties",
        size: "250ml",
        price: 7.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 336,
        period: "try me",
        img: body102,
        type: "OE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "clean and care for the body. Enriched in minerals recognized for their revitalizing properties",
        size: "250ml",
        price: 8.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 337,
        period: "try me",
        img: body103,
        type: "OE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "rose clean and care for the body. Enriched in minerals recognized for their revitalizing properties",
        size: "250ml",
        price: 7.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 338,
        period: "try me",
        img: body104,
        type: "OE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "Peach clean and care for the body. Enriched in minerals recognized for their revitalizing properties",
        size: "250ml",
        price: 8.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 339,
        period: "try me",
        img: body105,
        type: "OE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "best seller",
        description: "Vanilla clean and care for the body. Enriched in minerals recognized for their revitalizing properties",
        size: "250ml",
        price: 8.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 340,
        period: "try me",
        img: body106,
        type: "OE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "pomegranate clean and care for the body. Enriched in minerals recognized for their revitalizing properties",
        size: "250ml",
        price: 9.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 341,
        period: "try me",
        img: body107,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 13.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 342,
        period: "try me",
        img: body108,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 14.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 343,
        period: "try me",
        img: body109,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "best seller",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 15.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 344,
        period: "try me",
        img: body110,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 13.90,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 345,
        period: "try me",
        img: body111,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 14.70,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 346,
        period: "try me",
        img: body112,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 15.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 347,
        period: "try me",
        img: body113,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 14.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 348,
        period: "try me",
        img: body114,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 13.75,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 349,
        period: "try me",
        img: body115,
        type: "DOVE shower gel",
        class: "showerGel",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "Discover a moisturising showerGel that gives you softer, smoother skin after just one shower.",
        size: "420ml",
        price: 16.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 350,
        period: "try me",
        img: body116,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 17.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 351,
        period: "try me",
        img: body117,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 18.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 352,
        period: "try me",
        img: body118,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 17.60,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 353,
        period: "try me",
        img: body119,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 16.80,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 354,
        period: "try me",
        img: body120,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "best seller",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 18.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 355,
        period: "try me",
        img: body121,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "best seller",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 18.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 356,
        period: "try me",
        img: body122,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 17.30,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 357,
        period: "try me",
        img: body123,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 19.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 358,
        period: "try me",
        img: body124,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 18.25,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 359,
        period: "try me",
        img: body125,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 19.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 360,
        period: "try me",
        img: body126,
        type: "DOVE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "super rich formula made from essential oils that helps minimize the signs of dry and aging skin",
        size: "400ml",
        price: 17.70,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 361,
        period: "try me",
        img: body127,
        type: "OE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "best seller",
        description: "Take care of your body with the OE Body Lotion enriched in 24H HYDRA complex for a soft and smooth skin",
        size: "480ml",
        price: 16.90,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 362,
        period: "try me",
        img: body128,
        type: "OE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "OE Body Lotion enriched in 24H HYDRA complex for moisturising your skin daily with Its creamy texture",
        size: "380ml",
        price: 15.40,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 363,
        period: "try me",
        img: body129,
        type: "OE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "Body Lotion enriched in 24H HYDRA for moisturising your skin daily with Its creamy texture for silk feeling",
        size: "450ml",
        price: 16.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 364,
        period: "try me",
        img: body130,
        type: "OE body Lotion",
        class: "bodyLotion",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "best seller",
        description: "Body Lotion enriched in 24H HYDRA for moisturising your skin daily with Its creamy texture for silk feeling",
        size: "350ml",
        price: 17.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 365,
        period: "try me",
        img: body131,
        type: "DOVE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "best seller",
        description: "dove creme with textures and fragrances, transform your skin care routine into a moment of 'me-time'",
        size: "360ml",
        price: 16.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 366,
        period: "try me",
        img: body132,
        type: "DOVE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "dove creme with textures and fragrances, transform your skin care routine into a moment of 'me-time'",
        size: "360ml",
        price: 19.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 367,
        period: "try me",
        img: body133,
        type: "DOVE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "dove creme with textures and fragrances, transform your skin care routine into a moment of 'me-time'",
        size: "360ml",
        price: 17.50,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 368,
        period: "try me",
        img: body134,
        type: "DOVE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "popular",
        description: "dove creme with textures and fragrances, transform your skin care routine into a moment of 'me-time'",
        size: "360ml",
        price: 20.10,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 369,
        period: "try me",
        img: body135,
        type: "DOVE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "dove creme with textures and fragrances, transform your skin care routine into a moment of 'me-time'",
        size: "360ml",
        price: 21.00,
        inCart: false,
        count: 0,
        total: 0
    },
    {
        id: 370,
        period: "try me",
        img: body136,
        type: "OE body Creme",
        class: "bodyCreme",
        link: "body",
        brand: "oe / dove",
        target:"woman",
        rank: "new",
        description: "perfect opportunity to gain some 'me- time', our OE body creams are thick, smooth and moisturising",
        size: "360ml",
        price: 18.60,
        inCart: false,
        count: 0,
        total: 0
    },

];







export const detailsProduct = {
    id: 295,
    period: "try me",
    img: hair216,
    type: "head&sholders collection",
    class: "collection",
    link: "hair",
    brand: "H&sholders",
    target:"woman",
    rank: "new",
    description: "SUPREME collection is avalible now for dunDrruff normal & itchy brittle hair from head&sholders",
    size: "400ml/350ml",
    price: 33.50,
    inCart: false,
    count: 0,
    total: 0    
};

